<template>
    <div class="mb-xl">
        <div :class="{ 'account__container py-none': fullWidth }">
            <div class="system-diagram mt-xl mb-lg">
                <slot name="diagram" :setActive="setActive" :inverter="system.inverter" :mppts="system.mppts" :activeMppt="activeMppt" />
            </div>
        </div>

        <div v-if="activeMppt" class="system-fields">
            <slot name="fields" :activeMppt="activeMppt" :inverter="system.$model.inverter" />
            <SystemMpptFlags
                class="mt-lg"
                :class="{ 'account__container py-none': fullWidth }"
                :flags="activeFlags"
            />
        </div>
    </div>
</template>

<script>
import { find } from 'lodash';
import SystemMpptFlags from "@/jobs/new/SystemMpptFlags";

export default {
    components: {
        SystemMpptFlags
    },

    props: {
        system: {
            type: Object,
            required: true
        },

        flags: {
            type: Array,
            default: () => []
        },

        // temperature: {
        //     type: Object,
        //     default: undefined
        // },

        // buildingType: {
        //     type: String,
        //     default: undefined
        // },

        fullWidth: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            active: null
        };
    },

    computed: {
        activeMppt() {
            return find(this.system.mppts.$each.$iter, { $model: { id: this.active }});
        },

        activeFlags() {
            return this.flags && this.flags.length >= this.active ? this.flags[this.active - 1] : undefined;
        }
    },

    methods: {
        setActive(mppt) {
            this.active = this.active === mppt ? null : mppt;
        },
    }
};
</script>

<style lang="scss" scoped>
    .system-diagram {
        position: relative;
        height: 250px;

        @media screen and (max-width: 799px) {
            width: 300px;
            height: 640px;
            margin: 0 auto;
        }

        .system--micro & {
            height: 120px;
        }
    }

    .system-fields {
        position: relative;
        margin: 0 -55px;
        padding: 55px;
        padding-bottom: 80px;
        background-color: #FF8100;
        background-image: linear-gradient(312deg, #ff8100 0%, #ef6e0b 50%);

        @media screen and (max-width: 699px) {
            margin: 0 -28px;
            padding: 55px 28px;
        }

        &::before {
            top: 0;
            left: 35%;
            border: solid transparent;
            content: "";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: transparent;
            border-top-color: #FFF;
            border-width: 15px;
            margin-left: -15px;
        }
    }
</style>
